import {useIdentityValidator} from '@app/hooks/useValidators';
import {SelectFormControlField} from '../FormField';
import type {FieldProps} from '../FormField';
import {useTranslation} from '@app/hooks/useTranslation';

export const IdentityField: React.FC<
	FieldProps<string> & {nonBinaryAllowed: boolean}
> = ({nonBinaryAllowed, ...props}) => {
	const [identityValidator] = useIdentityValidator();
	const t = useTranslation();
	return (
		<SelectFormControlField
			validate={identityValidator}
			label={t('common.label_identity')}
			placeholder={t('common.label_identity')}
			{...props}
		>
			<option value="">{t('common.label_identity')}</option>
			<option value="F">{t('common.genderoption_text_female')}</option>
			<option value="M">{t('common.genderoption_text_male')}</option>
			{nonBinaryAllowed && (
				<option value="NonBinary" data-testid="non-binary-field">
					{t('common.genderoption_text_nonbinary')}
				</option>
			)}
		</SelectFormControlField>
	);
};
